import React from 'react';
import './SuccessModal.css';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  confirmText?: string;
  variant?: 'success' | 'error';
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  confirmText = 'OK',
  variant = 'success'
}) => {
  if (!isOpen) return null;

  const isError = variant === 'error';

  return (
    <div className="success-modal-overlay">
      <div className={`success-modal ${isError ? 'error-modal' : ''}`}>
        <div className="success-modal-header">
          <div className={`success-icon ${isError ? 'error-icon' : ''}`}>
            {isError ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
              </svg>
            )}
          </div>
          <h3 className="success-modal-title">{title}</h3>
        </div>
        
        <div className="success-modal-body">
          <p className="success-modal-message">{message}</p>
        </div>
        
        <div className="success-modal-footer">
          <button 
            className="success-modal-button"
            onClick={onClose}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
